import Vue from 'vue'
import VueApollo from 'vue-apollo'
import store from './store'
import { createApolloClient } from 'vue-cli-plugin-apollo/graphql-client'
import { InMemoryCache, defaultDataIdFromObject } from 'apollo-cache-inmemory'

// Install the vue plugin
Vue.use(VueApollo)

// Name of the localStorage item
const AUTH_TOKEN = 'accessToken'

// Http endpoint
const httpEndpoint = process.env.VUE_APP_GRAPHQL_HTTP || 'http://localhost:4000/graphql'

// Config
const defaultOptions = {
  // You can use `https` for secure connection (recommended in production)
  httpEndpoint,
  // You can use `wss` for secure connection (recommended in production)
  // Use `null` to disable subscriptions
  // wsEndpoint: process.env.VUE_APP_GRAPHQL_WS || 'ws://localhost:4000/graphql',
  wsEndpoint: null,
  // LocalStorage token
  tokenName: AUTH_TOKEN,
  // Enable Automatic Query persisting with Apollo Engine
  persisting: false,
  // Use websockets for everything (no HTTP)
  // You need to pass a `wsEndpoint` for this to work
  websocketsOnly: false,
  // Is being rendered on the server?
  ssr: false,

  // Override default apollo link
  // note: don't override httpLink here, specify httpLink options in the
  // httpLinkOptions property of defaultOptions.
  // link: myLink

  // Override default cache
  cache: new InMemoryCache({
    freezeResults: false,
    dataIdFromObject: object => {
      switch (object.__typename) {
        case 'Airport': return `Airport:${object.iata}`
        case 'User': return `User:${object.user_id}`
        case 'Document': return `Document:${object.document_id}`
        case 'Pool': return `Pool:${object.pool_id}`
        case 'WikiEntityType': return `WikiEntityType:${object.entity_type_id}`
        case 'WikiEntity': return `WikiEntity:${object.entity_id}`
        case 'WikiLink': return `WikiLink:${object.link_id}`
        case 'WikiDirectedLink': return `WikiDirectedLink:${object.directed_link_key}`
        case 'WikiAttribute': return `WikiAttribute:${object.attribute_id}`
        case 'WikiLinkType': return `WikiLinkType:${object.link_type_id}`
        case 'WikiDirectedLinkType': return `WikiDirectedLinkType:${object.directed_link_type_key}`
        case 'WikiAttributeType': return `WikiAttributeType:${object.attribute_type_id}`
        default: return defaultDataIdFromObject(object) // fall back to default handling
      }
    },
    cacheRedirects: {
      Query: {
        getAllowedTypesByEntityTypeIds: (_, args, { getCacheKey }) =>
          args.entity_type_ids.map(id =>
            getCacheKey({ __typename: 'WikiEntityType', entity_type_id: id }))
      }
    }
  }),

  // Override the way the Authorization header is set
  // getAuth: (tokenName) => ...
  getAuth: tokenName => {
    // get the authentication token from local storage if it exists
    // return the headers to the context so httpLink can read them
    const accessToken = localStorage.getItem('accessToken')
    if (accessToken === null) {
      return ''
    }
    if (Vue.prototype.$auth0.isAuthenticated() === false && accessToken !== null) {
      Vue.prototype.$auth0.login()
    }
    return `Bearer ${accessToken}`
  }
}

// Create apollo client
var { apolloClient, wsClient } = createApolloClient({
  ...defaultOptions
})
apolloClient.wsClient = wsClient

// Call this in the Vue app file
const createProvider = function createProvider () {
  // Create vue apollo provider
  const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
    defaultOptions: {
      $query: {
        // fetchPolicy: 'cache-and-network',
      }
    },
    errorHandler (error) {
      // if accessToken is not valid anymore just try to get a new one.
      // in worst case user should have to login again.
      if (error.networkError && error.networkError.statusCode === 401) {
        Vue.prototype.$auth0.login()
      } else {
        store.commit('addError', error.message)
        console.error(error)
      }
    }
  })
  return apolloProvider
}

export {
  apolloClient,
  createProvider
}
